import { useEffect, useState } from 'react'
import {
  fetchAndActivateRemoteConfig,
  getChatAudioRecordEnabledFromRemote,
} from 'configs/firebase'

/** `true` até o fetch; depois reflete `chat_audio_record_enabled` (padrão: true). */
export function useChatAudioRecordEnabled(): boolean {
  const [enabled, setEnabled] = useState(true)

  useEffect(() => {
    let cancelled = false
    void (async () => {
      await fetchAndActivateRemoteConfig()
      if (cancelled) return
      setEnabled(getChatAudioRecordEnabledFromRemote())
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return enabled
}
